// This icon file is generated automatically.
var PReloadTimeOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M7.38 3.27h-.75a.13.13 0 00-.13.12v4.3c0 .04.02.08.05.1l2.58 1.89c.06.04.14.03.18-.03l.45-.6a.12.12 0 00-.03-.18L7.5 7.26V3.39a.13.13 0 00-.12-.12zm3.43 1.17l2.45.6c.08.02.16-.04.16-.12V2.4c0-.1-.11-.17-.2-.1l-2.46 1.92c-.08.07-.05.2.05.22zm2.62 4.7l-.88-.3a.12.12 0 00-.16.08l-.1.23a5.49 5.49 0 01-5.1 3.38A5.48 5.48 0 012.1 9.15a5.52 5.52 0 019.46-5.56l.93-.73a6.7 6.7 0 00-12 4.2A6.72 6.72 0 0013.5 9.32a.13.13 0 00-.08-.16z", "fill-rule": "nonzero" } }] }, "name": "p-reload-time", "theme": "outlined" };
export default PReloadTimeOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PReloadTimeOutlined.js
// module id = 3595
// module chunks = 0